import React from "react";
import { IconProps } from "../icon";

export const GitPullRequestIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M18 15a3 3 0 100 6 3 3 0 000-6zm0 0V8a2 2 0 00-2-2h-3M6 9a3 3 0 100-6 3 3 0 000 6zm0 0v12"
    />
  </svg>
);
